import React from 'react';
import { FormattedMessage } from 'react-intl';
import { compose, prop } from 'ramda';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import renderIf from 'app/enhancers/renderIf';
import wrapIn from 'app/enhancers/wrapIn';
import S from 'app/features/success/offlineViewingBlock/components/OfflineViewingBlock.styled';
import LocalizedLink from 'app/features/localization/components/LocalizedLink/LocalizedLink';
import Heading from 'app/components/layout/Heading.styled';
import Text from 'app/components/layout/Text.styled';
import BlockWrapper from 'app/features/success/components/BlockWrapper';
import { isVisible } from 'app/features/success/offlineViewingBlock/selectors';
import { appStoreNavigated } from 'app/features/success/actions';

const UI = ({ appStoreNavigated }) => (
  <article data-t="offlineviewing-block">
    <Heading size="l" as={S.OfflineViewingBlock.Title}>
      <FormattedMessage id="success_offline_viewing_title" />
    </Heading>
    <S.OfflineViewingBlock.Wrapper>
      <S.OfflineViewingBlock.ImageWrapper>
        <S.OfflineViewingBlock.BackgroundImage
          src={`${window.etp.config.assetsUrl}img/success/vrv-art.png`}
          srcSet={`${window.etp.config.assetsUrl}img/success/vrv-art@2x.png 2x`}
          alt="Offline Viewing Side Image"
        />
      </S.OfflineViewingBlock.ImageWrapper>
      <S.OfflineViewingBlock.Content>
        <Heading size="s" as={S.OfflineViewingBlock.Subtitle}>
          <FormattedMessage id="success_offline_viewing_subtitle" />
        </Heading>
        <Text as={S.OfflineViewingBlock.Description} size="l">
          <FormattedMessage id="success_offline_viewing_description" />
        </Text>
        <S.OfflineViewingBlock.ButtonsWrapper>
          <LocalizedLink to="https://play.google.com/store/apps/details?id=com.crunchyroll.crunchyroid">
            <S.OfflineViewingBlock.NativeAppImage
              data-t="google-play-link"
              src={`${window.etp.config.assetsUrl}img/success/google-play-3-x.png`}
              srcSet={`${window.etp.config.assetsUrl}img/success/google-play-3-x@2x.png 2x`}
              onClick={() => appStoreNavigated({ appStore: 'googleplay' })}
            />
          </LocalizedLink>
          <LocalizedLink to="https://apps.apple.com/us/app/crunchyroll/id329913454">
            <S.OfflineViewingBlock.NativeAppImage
              data-t="apple-store-link"
              src={`${window.etp.config.assetsUrl}img/success/apple-app-store-3-x.png`}
              srcSet={`${window.etp.config.assetsUrl}img/success/apple-app-store-3-x@2x.png 2x`}
              onClick={() => appStoreNavigated({ appStore: 'apple' })}
            />
          </LocalizedLink>
        </S.OfflineViewingBlock.ButtonsWrapper>
      </S.OfflineViewingBlock.Content>
    </S.OfflineViewingBlock.Wrapper>
  </article>
);

const OfflineViewingBlock = compose(
  connect({ isVisible }, { appStoreNavigated }),
  renderIf(prop('isVisible')),
  wrapIn(BlockWrapper),
)(UI);

UI.propTypes = { appStoreNavigated: PropTypes.func.isRequired };

export { UI };

export default OfflineViewingBlock;
